import axios from 'axios'
import { showLoadingToast, showFailToast, closeToast } from 'vant'
import { snStorage, nfcStorage } from './storage'


function startLoading() {   
  showLoadingToast({
    message: '加载中...',
    duration: 0,
    forbidClick: true
  })
}
function endLoading() {    
  closeToast()
}

let needLoadingRequestCount = 0
export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}


// 创建 axios 实例
const request = axios.create({
  // baseURL: process.env.VUE_APP_API_BASE_URL + '/pk/v260818/',
  // baseURL: process.env.NODE_ENV === 'production' ? 'https://api.picobuco.com/pk/v260818/' : '/pk/v260818/',
  baseURL: 'https://api.picobuco.com/pk/v260818/',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'auth_token': 'tk10087-hkpk-663-10001'
  }
})

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('=============== '+ config.url +' ===============')
      console.log('请求参数')
      console.log(config.data)
    }
    if (config.method === 'post') {
      // config.data.auth_token = 'tk10087-hkpk-663-10001'
      config.data.timestamp = new Date().getTime()
      config.data.platform = detectDevice()
      config.data.sn = snStorage.get() || ''
      config.data.nfcSign = nfcStorage.get() || []
      config.data.sign = signature(config.data)
    } else if (config.method === 'get') {
      // config.params.auth_token = 'tk10087-hkpk-663-10001'
      config.params.timestamp = new Date().getTime()
      config.params.platform = detectDevice()
      config.params.sn = snStorage.get() || ''
      config.params.nfcSign = nfcStorage.get() || []
      config.params.sign = signature(config.params)
    }
    if (config.url == 'Index/index') {
      //
    } else {
      showFullScreenLoading()
    }
    
    return config
  },
  (error) => {
    tryHideFullScreenLoading()
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('请求结果') 
      console.log(response.data)
      console.log('========================================================================================')
      console.log(' ')
    }

    tryHideFullScreenLoading()
    const status = response.status
    const { data, message } = response.data
    if (status === 200) {
      return data
    } else if (status === 401) {
      // tokenStorage.remove()
      showFailToast('登录已过期，请重新登录')
      window.dispatchEvent(new CustomEvent('show-login'))
      return Promise.reject(new Error('登录已过期'))
    } else {
      showFailToast(message || '请求失败')
      return Promise.reject(new Error(message || '请求失败'))
    }
  },
  (error) => {
    tryHideFullScreenLoading()
    if (error.response) {
      const { status, data } = error.response
      switch (status) {
        case 401:
          // tokenStorage.remove()
          window.dispatchEvent(new CustomEvent('show-login'))
          showFailToast('登录已过期，请重新登录')
          break
        case 404:
          showFailToast('请求的资源不存在')
          break
        case 500:
          showFailToast('服务器错误，请稍后重试')
          break
        default:
          showFailToast(data?.message || '请求失败')
      }
    } else if (error.request) {
      showFailToast('网络异常，请检查网络连接')
    } else {
      showFailToast(error.message || '请求失败')
    }
    return Promise.reject(error)
  }
)

/**
 * 签名
 * @param data        提交的数据
 * @returns {string}
 */
export function signature(data) {
	let utils = require('./util.js')
	let md5 = require('./md5.js')
	let str = ''
	data = utils.ksort(data)
	for (let key in data) {
		str = str + '&' + key + '=' + data[key]
	}
	str = str.substr(1)
	str += md5.hexMD5('eh3f7c506668778cda2fd9159aebfae5tk10087-hkpk-663-10001' + data.timestamp)
	str += 'eh3f7c506668778cda2fd9159aebfae5'
	data.sign = md5.hexMD5(str)
	return data.sign
}

/**
 * 判断当前系统
 */
export function detectDevice() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
        // 这里可以加载Android特有的资源或执行特定操作
        return 'android'
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        // 这里可以加载iOS特有的资源或执行特定操作
        return 'ios'
    } else {
        return 'unknown'
    }
}

export default request